<template>
    <div class="profile-bounding">
        <div class="profile-header">
            <div class="header-container">
                <h1 class="profile-title-text">My Profile</h1>
                <button class="profile-exit-button" @click="closeModal">X</button>
            </div>
            <div class="tabs">
                <div class="tab" :class="{ active: activeTab === 'tab1' }" @click="activeTab = 'tab1'">
                    Most Recent Searches
                </div>
                <div class="tab" :class="{ active: activeTab === 'tab2' }" @click="activeTab = 'tab2'">
                    Most Searched Terms
                </div>
                <div class="tab" :class="{ active: activeTab === 'tab3' }" @click="activeTab = 'tab3'">
                    License Information
                </div>
            </div>
        </div>

        <div class="profile-main-section">
            <div class="profile-content">
                <div class="profile-tabs-content">
                    <div class="profile-tab-content" v-if="activeTab === 'tab1'">
                        <h2>Most Recent Searches</h2>
                        <div v-if="loadingError" class="error-message">
                            {{ loadingError }}
                        </div>
                        <div v-else>
                            <div class="statistic-header">
                                <span class="stat-name-header">Term</span>
                                <span class="stat-value-header">Date Searched</span>
                                <span class="stat-search-header">Search again</span>
                            </div>
                            <div v-for="stat in items" :key="stat" class="statistic">
                                <span class="stat-name">{{ stat.query }}</span>
                                <span class="stat-value">{{ formatTime(stat.time) }}</span>
                                <button class="stat-search" title="Search again">
                                    <img src="@/assets/search_icon.svg" alt="Search" class="stat-search-button" @click="search(stat.query)"/>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="profile-tab-content" v-if="activeTab === 'tab2'">
                        <h2>Most Searched Terms</h2>
                        <div v-if="loadingError" class="error-message">
                            {{ loadingError }}
                        </div>
                        <div v-else>
                            <div class="statistic-header">
                                <span class="stat-name-header">Term</span>
                                <span class="stat-value-header">Count</span>
                                <span class="stat-search-header">Search again</span>
                            </div>
                            <div v-for="stat in items_searched" :key="stat" class="statistic">
                                <span class="stat-name">{{ stat.query }}</span>
                                <span class="stat-value">{{ stat.count }}</span>
                                <button class="stat-search" title="Search again">
                                    <img src="@/assets/search_icon.svg" alt="Search" class="stat-search-button" @click="search(stat.query)"/>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="profile-tab-content" v-if="activeTab === 'tab3'">
                        <h2>License Information</h2>
                        <div v-if="licenseInfo">
                            <div v-if="licenseInfo.expiration_date" class="statistic">
                                <span class="stat-name">Expiration date</span>
                                <span class="stat-value">{{
                                    licenseInfo.expiration_date
                                }}</span>
                            </div>
                            <div v-if="licenseInfo.max_docs" class="statistic">
                                <span class="stat-name">Maximum document count</span>
                                <span class="stat-value">{{ licenseInfo.max_docs }}</span>
                            </div>
                            <div v-if="licenseInfo.max_users" class="statistic">
                                <span class="stat-name">Maximum active users</span>
                                <span class="stat-value">{{ licenseInfo.max_users }}</span>
                            </div>
                            <div class="statistic-divider"></div>
                            <div v-if="licenseInfo.days_left" class="statistic">
                                <span class="stat-name">Days left</span>
                                <span class="stat-value">{{ licenseInfo.days_left }}</span>
                            </div>
                            <div v-if="licenseInfo.docs_left" class="statistic">
                                <span class="stat-name">Documents left</span>
                                <span class="stat-value">{{ licenseInfo.docs_left }}</span>
                            </div>
                            <div v-if="licenseInfo.users_left" class="statistic">
                                <span class="stat-name">Users left</span>
                                <span class="stat-value">{{ licenseInfo.users_left }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { useCookies } from 'vue3-cookies';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export default {
    name: "MyProfile",
    props: {
      isVisible: {
        type: Boolean,
        required: true
      }
    },
    computed: {
        items() {
            return this.$store.state.recentExpressions;
        },
        items_searched() {
            return this.$store.state.top10Expressions;
        }
    },
    setup() {
      const { cookies } = useCookies();
      return { cookies };
    },
    data() {
        return {
            suggestList: [],
            term: "",
            activeTab: "tab1",
            licenseInfo: {},
            loadingError: null,
            page: 1,
        };
    },
    methods: {
        formatTime(datetimeStr) {
            return dayjs.utc(datetimeStr).tz(dayjs.tz.guess()).format('YYYY-MM-DD HH:mm');
        },
        closeModal() {
            this.$emit('close-modal'); // Emit an event when the close button is clicked
        },
        search(searchQuery) {
            this.closeModal()
            this.$store.commit('setSelectedTab', {})
            this.$store.commit('setSearchParams', {
                searchPhrase: searchQuery,
                itemsPerPage: this.$root.recordsPerPage,
                tab: "",
                aggs: this.$store.state.searchParams.aggs,
                filters: {},
                sort: {}
            })

            if (this.$route.path === '/results') {
                this.$store.dispatch("search", {});
            } else {
                this.$router.push("/results")
            }
        },
        loadData(){
            this.loadingError = null;

            // Get license info
            try {
                this.licenseInfo = this.cookies.get('licenseData')
            } catch (error) {
                console.error('Error loading license data:', error);
            }

            let historyData = {
                type: 'HISTORY',
                rows: '10'
            }

            this.axios.post(this.$root.URL_BACKEND + '/my-profile',historyData).then(response => {
                console.log(response.data.response.docs)
                this.$store.commit('setrecentExpressions', response.data.response.docs);
            }).catch((e) => {
                console.log(e);
                this.loadingError = "Could not fetch recentExpressions"
            });

            console.log('getSearchData')

            let topData = {
                type: 'TOP',
                rows: '10'
            }

            this.axios.post(this.$root.URL_BACKEND + '/my-profile',topData).then(response => {
                console.log(response.data.response.docs)
                this.$store.commit('settop10Expressions', response.data.response.docs);
            }).catch((e) => {
                console.log(e);
                this.loadingError = "Could not fetch top10Expressions"
            });
        }
    },
    watch: {
      isVisible(newValue) {
        if (newValue) {
            this.loadData();
        }
      }
    },
    mounted() {
        console.log("mounted");
        this.loadData();
        
    },
};
</script>

<style lang="scss" scoped src="@/assets/css/MyProfile.scss"></style>
